import React from "react";
import { Row, Col, Label, Input } from "reactstrap";
import {
    ECN_WILL_CHANGE_GROUPS,
    ECN_WILL_CHANGE_RETIRED,
    willChangeLabel,
} from "../constants/ecnWillChangeOptions";

/**
 * Tester request (2026-10-01): the "ECN Will Change" checklist, headed as such,
 * in the legacy sequence with one column per subject. Used by the Create/Edit
 * form (editable) and by the document view (read-only).
 *
 * Props:
 *   checked        — the stored tokens that are ticked
 *   onToggle(opt)  — editable mode; absent = read-only
 *   otherText      — the free text of "Other"
 *   onOtherText(v) — editable mode
 */
export default function EcnWillChangeGrid({ checked = [], onToggle, otherText = "", onOtherText }) {
    const readOnly = typeof onToggle !== "function";
    const retiredChecked = ECN_WILL_CHANGE_RETIRED.filter((t) => checked.includes(t));

    const box = (opt) => {
        const isChecked = checked.includes(opt);
        return (
            <div key={opt} className="mb-2">
                <div className="form-check">
                    <Input
                        type="checkbox"
                        id={`ecn-will-change-${opt.replace(/[^A-Za-z0-9]+/g, "-")}`}
                        checked={isChecked}
                        readOnly={readOnly}
                        disabled={readOnly && !isChecked}
                        onChange={readOnly ? undefined : () => onToggle(opt)}
                    />
                    <Label className="form-check-label" for={`ecn-will-change-${opt.replace(/[^A-Za-z0-9]+/g, "-")}`}>
                        {willChangeLabel(opt)}
                    </Label>
                </div>
                {opt === "Other" && isChecked && (
                    readOnly
                        ? (otherText ? <div className="small text-muted ms-4">{otherText}</div> : null)
                        : (
                            <Input
                                type="text"
                                className="mt-2"
                                placeholder="Please specify..."
                                value={otherText || ""}
                                onChange={(e) => onOtherText && onOtherText(e.target.value)}
                            />
                        )
                )}
            </div>
        );
    };

    return (
        <div className="mb-3">
            <Label className="fw-semibold">ECN Will Change</Label>
            <Row>
                {ECN_WILL_CHANGE_GROUPS.map((g) => (
                    <Col md={3} key={g.key}>
                        {g.items.map(box)}
                    </Col>
                ))}
            </Row>
            {retiredChecked.length > 0 && (
                <div className="small text-muted">
                    Also recorded on this document: {retiredChecked.map(willChangeLabel).join(", ")}
                </div>
            )}
        </div>
    );
}
